import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const getStatusMessage = async (tcrid) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  try {
    const response = await axios.get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getExecutionMessage&tcrid=${tcrid}&companyid=${user.companyid}`,
    );
    return response.data;
  } catch (error) {
    throw new Error("Error fetching status message", error);
  }
};

const useGetStatusMessageQuery = (tcrid, options = {}) => {
  return useQuery({
    queryKey: ["statusMessage", tcrid],
    queryFn: () => getStatusMessage(tcrid),
    enabled: options.enabled,
    // refetchInterval: 1000,
    ...options,
  });
};

export default useGetStatusMessageQuery;
